export default "__VITE_ASSET__0a997bd8__"